<template>
    <div>
        <span>{{ message }}</span>
    </div>
</template>

<script>
export default {
    name: "VoiceAgentPhoneNumberOutboundAgentChanged",
    props: {
        activity: {
            type: Object,
            required: true
        }
    },
    computed: {
        message() {
            return this.$t('notification.voiceAgentPhoneNumberOutboundAgentChanged', {
                actor: this.$_.get(this.activity, 'actorUser.name'),
                phoneNumber: this.$_.get(this.activity, 'payload.phoneNumber'),
                agentName: this.$_.get(this.activity, 'payload.agentName')
            });
        }
    }
};
</script>

